import React, { useEffect, useState } from "react";
import { FormOutlined } from "@ant-design/icons";
import { Anchor, Col, Row, Skeleton } from "antd";
import { useNavigate } from "react-router-dom";

import AppContainer from "~v2/components/AppContainer/AppContainer";
import { contactsProperty } from "~constants";
import { getContacts } from "../../http-request/contacts";
import jwtDecode from "jwt-decode";

const { Link } = Anchor;

const Contacts = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const loginAs = jwtDecode(token).loginAs;
  const [contacts, setContacts] = useState([]);

  const loadContacts = async () => {
    await getContacts().then(({ result }) => {
      let _contacts = [];
      Object.keys(result).forEach((key) => {
        contactsProperty.forEach((contact) => {
          if (contact.property === key) {
            _contacts.push({
              anchor: `${contact.type !== "link" ? contact.type : ""}${
                result[key]
              }`,
              label: contact.label,
              title: result[key],
              type: contact.type,
            });
          }
        });
      });
      setContacts(_contacts);
    });
  };

  useEffect(() => {
    loadContacts();
  }, []);

  return (
    <AppContainer title="GENSAN TOURISM DEPT. CONTACT INFORMATION">
      <center>
        {loginAs === "Administrator" && (
          <Row className="fullWidth" align="middle" justify="end">
            <FormOutlined
              onClick={() => navigate("./edit")}
              style={{ fontSize: 25, margin: "15px" }}
            />
          </Row>
        )}

        {contacts.length > 0 ? (
          contacts.map((_contact, key) => (
            <Row key={key} style={{ marginLeft: "10%" }}>
              <Col span={8} align="start" justify="start">
                <strong>{_contact.label}</strong>
              </Col>
              <Col span={12} align="start" justify="start">
                <Anchor align="start" justify="start">
                  <Link
                    target={"_blank"}
                    href={_contact.anchor}
                    title={
                      _contact.type === "link"
                        ? _contact.title.replace(/^https?:\/\//, "")
                        : _contact.title
                    }
                  />
                </Anchor>
              </Col>
            </Row>
          ))
        ) : (
          <Skeleton />
        )}
      </center>
    </AppContainer>
  );
};

export default Contacts;
